import {Injectable} from '@angular/core';
import {MotorQuoteDTO} from '../../models/MotorQuoteDTO.interfaces';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class DateHelperService {
  createDateObj(dateString: string): Date {
    const [day, month, year] = dateString.split('/').map(Number);

    // Crea un nuovo oggetto Date. Ricorda che i mesi in JavaScript sono indicizzati da 0 (Gennaio è 0)
    const date = new Date(year, month - 1, day);

    // Controlla se la data è valida
    if (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day) {
      return date;
    } else {
      throw new Error('Data non valida');
    }
  }

  isDateMoreThan60Days(date: Date): boolean {
    const currentDate = new Date();
    const diffTime = date.getTime() - currentDate.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const isMore = diffDays > 60;

    return isMore;
    // return false;
  }

  checkDateFromObject(motorData: MotorQuoteDTO) {
    const expireDate =
      motorData.response.insuranceData.billing.fieldset[0].fields.expireDatePrvContract.value;
    if (!expireDate) return false;

    const date = this.createDateObj(expireDate);

    return this.isDateMoreThan60Days(date);
  }

  checkDateForAnalytics(motorData: MotorQuoteDTO) {
    const expireDatePrvContract =
      motorData.response.insuranceData.billing.fieldset[0].fields.expireDatePrvContract;
    const expireDateString =
      expireDatePrvContract?.displayValue ?? expireDatePrvContract?.value ?? null;
    const expireDate = expireDateString
      ? moment(expireDateString, 'DD/MM/YYYY').startOf('day')
      : null;
    const diff = expireDate ? expireDate.diff(moment().startOf('day'), 'days') : null;

    const analyticsDateObj = {
      scadenza: expireDateString,
      giorni_scadenza: diff?.toString() ?? null,
      tipo_scadenza: diff ? (diff > 60 ? 'oltre_60' : 'entro_60') : null,
    };
    return {expireDateString, expireDays: diff, analyticsDateObj};
  }
}
